import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Ansprechpartner:", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Kein Ansprechpartner")

import { useAddProject } from '@/store/addProject'
import { IonSelect, IonSelectOption } from '@ionic/vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInput',
  setup(__props) {

const addProjectStore = useAddProject()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(IonSelect), {
      modelValue: _unref(addProjectStore).projectActiveData.contact,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(addProjectStore).projectActiveData.contact) = $event)),
      enterkeyhint: "next",
      class: _normalizeClass(["w-full min-h-10 h-10 my-1 bg-zewotherm-lightgrey p-2 font-bold rounded-lg outline-none", [_unref(addProjectStore).errorResponse.contact && _unref(addProjectStore).errorResponse.contact.length > 0 ? 'border-2 border-red-500' : '']])
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSelectOption), { value: null }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).contactToChoose, (contact, index) => {
          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
            value: contact,
            key: index
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(contact.last_name) + ", " + _toDisplayString(contact.first_name), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.contact, (errorMsg, index) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "text-red-500",
        key: index
      }, _toDisplayString(errorMsg), 1))
    }), 128))
  ]))
}
}

})